import React from 'react';
import { decodeA3p } from '../utils/a3pDecode';

/**
 * A3pInlineDecode — the decoded a3p (Secure Signals) entries, shown right under
 * the raw param in the Raw tab, so checking "is Meta in this auction?" needs no
 * trip to Inspect. One row per adapter the app registered; an SDK-bidding buyer
 * with a non-empty signal sent GAM a bidder token.
 */
export default function A3pInlineDecode({ value }) {
  const dec = decodeA3p(value);
  if (!dec.ok) {
    return <div data-testid="a3p-inline" style={{ fontSize: 11, color: 'var(--warn-text)', padding: '4px 0' }}>{dec.error}</div>;
  }
  return (
    <div data-testid="a3p-inline" style={{ marginTop: 4, border: '1px solid var(--line)', borderRadius: 4, background: 'var(--card)', fontSize: 11 }}>
      <div style={{ padding: '3px 8px', color: 'var(--muted)', borderBottom: '1px solid var(--line)' }}>
        {dec.entries.length} adapter{dec.entries.length === 1 ? '' : 's'} · {dec.bytes} bytes
      </div>
      {dec.entries.map((e, i) => {
        const len = e.gzipBase64 ? e.gzipBase64.length : e.signalLength;
        return (
          <div key={e.adapter + i} style={{ display: 'grid', gridTemplateColumns: '110px 1fr auto', gap: 8, padding: '3px 8px', borderBottom: i < dec.entries.length - 1 ? '1px solid var(--line)' : 'none' }}>
            <span style={{ fontWeight: 600, color: 'var(--ink)' }}>{e.buyer}</span>
            <span style={{ fontFamily: 'var(--font-mono)', color: 'var(--muted)', wordBreak: 'break-all' }}>
              {e.adapter}
              {(e.sdkVersion || e.adapterVersion) && ` · sdk ${e.sdkVersion || '?'} · adapter ${e.adapterVersion || '?'}`}
            </span>
            <span style={{ color: len ? 'var(--success-text)' : 'var(--muted)', whiteSpace: 'nowrap' }}>
              {len ? `token ${len} chars${e.gzipBase64 ? ' (gzip)' : ''}` : 'no token'}
            </span>
          </div>
        );
      })}
    </div>
  );
}
